

















































import { Component, Vue } from "vue-property-decorator";
import { LocationsApi, GetLocationsResponse } from "../../../../apis";
import { DataOptions, DataTableHeader } from "vuetify";
@Component({
  components: {},
})
export default class AdminCustomerList extends Vue {
  pagingOption: DataOptions | null = null;
  totalItems = 0;
  showDialog = false;
  locationSearch = "";
  selectedPermisstionId = "";
  selectedPermisstion = {} as any;
  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  headersLocation = [
    {
      text: "Location Name",
      align: "start",
      value: "locationName",
      class: ["tw-whitespace-no-wrap", "tw-p-4"],
    },
    {
      text: "Customer Name",
      align: "start",
      value: "customerName",
      class: ["tw-whitespace-no-wrap", "tw-p-4"],
    },
  ] as DataTableHeader[];
  tableLocationData = [] as any;
  locationResponse: GetLocationsResponse;
  locationSearchRespone: GetLocationsResponse;

  async onSearch() {
    await this.getActiveLocationsMobileWeb();
  }

  toggleLocation(item) {
    this.$emit("location-selected", item);
  }

  async created() {
    await this.getActiveLocationsMobileWeb();
  }

  async getActiveLocationsMobileWeb() {
    this.$util.showLoading();
    try {
      const res = await new LocationsApi().searchActiveLocations({keySearch: this.locationSearch});
      this.tableLocationData = res.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
